import { put } from 'redux-saga/effects';
import * as types from './countryActionTypes';
import { getCountiesForSeason } from '../../api/countyAPI';

export function* onSeasonSaga({ season }) {
  yield put({
    type: types.GET_COUNTRIES_REQUEST,
    season,
  });
}
export function* getCountriesForSeasonSaga({ season }) {
  const seasonId = season.sfId;
  try {
    const countries = yield getCountiesForSeason(seasonId);
    if (countries && countries.error) {
      yield put({
        type: types.GET_COUNTRIES_ERROR,
        error: countries.error,
      });
    } else {
      yield put({
        type: types.GET_COUNTRIES_SUCCESS,
        countries,
      });
      if (countries.length === 1) {
        yield put({
          type: types.SELECT_COUNTRY,
          countrySfId: countries[0].sfId,
        });
      }
    }
  } catch (error) {
    yield put({
      type: types.GET_COUNTRIES_ERROR,
      error,
    });
  }
}



// WEBPACK FOOTER //
// ./src/store/country/countrySaga.js